/**
 * Main entry point for the Nepali DateTime Picker library
 */

// Core components
import NepaliDateTimePicker from './core/NepaliDateTimePicker';
import DatePicker from './core/pickers/DatePicker';
import DateTimePicker from './core/pickers/DateTimePicker';
import DateRangePicker from './core/pickers/DateRangePicker';
import DateTimeRangePicker from './core/pickers/DateTimeRangePicker';

// Calendar implementations
import NepaliCalendar from './core/calendar/NepaliCalendar';
import EnglishCalendar from './core/calendar/EnglishCalendar';

// Utilities
import NepaliDateConverter from './core/converters/NepaliDateConverter';

// Styles
import './styles/core.css';

// Export the main class as default
export default NepaliDateTimePicker;

// Named exports for advanced usage
export {
  DatePicker,
  DateTimePicker,
  DateRangePicker,
  DateTimeRangePicker,
  NepaliCalendar,
  EnglishCalendar,
  NepaliDateConverter
};

// For UMD builds, also attach to the default export
NepaliDateTimePicker.DatePicker = DatePicker;
NepaliDateTimePicker.DateTimePicker = DateTimePicker;
NepaliDateTimePicker.DateRangePicker = DateRangePicker;
NepaliDateTimePicker.DateTimeRangePicker = DateTimeRangePicker;
NepaliDateTimePicker.NepaliCalendar = NepaliCalendar;
NepaliDateTimePicker.EnglishCalendar = EnglishCalendar;
NepaliDateTimePicker.NepaliDateConverter = NepaliDateConverter;